module.exports = __webpack_public_path__ + "static/Tobiasz_2-45faef85400b5fe2402b3c6e059de962.jpg";